import {Component, computed, effect, input, model, output, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AppBaseComponent} from '../../../shared/components/app-base-component/app-base-component';
import {finalize} from 'rxjs';

@Component({
  selector: 'app-verify-phone',
  imports: [
    FormsModule
  ],
  templateUrl: './verify-phone.html',
  styleUrl: './verify-phone.css',
})
export class VerifyPhone extends AppBaseComponent {
  phone = model<any>('');
  countryCode = model<any>('');
  otp = model<any>('');

  completePhone = computed(() => this.countryCode() + this.phone());
  showMessage = signal(false)
  saved = output();
  timer: any;
  numberUsed = signal(false);

  constructor() {
    super();
    effect(() => {
      let length = this.phone().length;
      this.showMessage.set(length == 10);
      if (length == 10) {
        this.checkPhone();
        // this.timer = setInterval(() => this.checkPhone(), 5 * 1000)
      } else {
        // if (this.timer) clearTimeout(this.timer)
      }
    });
  }

  checkPhone() {
    this.loading.set(true);
    this.http.post('user/verify-phone', {code: this.countryCode(), phone: this.phone()})
      .pipe(
        finalize(() => this.loading.set(false))
      )
      .subscribe({
        next: (res: any) => {
          switch (res.message) {
            case 'OK':
              this.saved.emit();
              clearTimeout(this.timer)
              break;
            case 'USED':
              this.numberUsed.set(true);
              clearTimeout(this.timer)
              break;
          }
        }, error: () => {
        }
      });
  }

  protected changeNumber() {
    this.phone.set('');
    this.numberUsed.set(false);
    this.showMessage.set(false);
    this.otpSent.set(false);

  }

  otpSent = signal(false);

  sendOtp() {
    if (this.otpSent()) {
      this.http.post('user/verify-phone', {code: this.countryCode(), phone: this.phone(), otp: this.otp()}).subscribe(res => {
        this.saved.emit();
      })
      return;
    }
    this.http.post('send-otp', {phone: this.phone(), 'countryCode': this.countryCode()}).subscribe(res => {
      this.otpSent.set(true);
    })
  }

  protected readonly input = input;
}
